import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo } from 'react'
import { Reception4 } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import { currencyFormat, separateThousands } from '../../../../../../utils/Helper'
import AdvertiserMarginColumn from './TotalSectionParts/AdvertiserMarginColumn'
import InfluencerPayoutMarginColumn from './TotalSectionParts/InfluencerPayoutMarginColumn'

export default observer(function TotalSocialSection({ influencer, campaignScenario, totalSocialGroup }) {
  const { campaign } = useContext(CampaignContext)

  const actions = useMemo(() => campaignScenario.actions.filter(action => action.influencer_id === influencer.id), [campaignScenario.actions, campaignScenario.actions.length])

  const influencerPrice = useMemo(() => actions.reduce((result, action) => result + action.influencerPrice, 0))
  const advertiserPrice = useMemo(() => actions.reduce((result, action) => result + action.totalAdvertiserPrice, 0))
  const ksaPrice = useMemo(() => actions.reduce((result, action) => result + action.totalKsaPrice, 0))
  const totalImpression = useMemo(() => actions.reduce((result, action) => result + action.impression, 0))
  const grossReach = useMemo(() => actions.reduce((result, action) => result + action.reach, 0), [actions, actions.length])
  const buyoutPrice = useMemo(() => actions.reduce((result, action) => result + action.buyoutPrice, 0))

  return (
    <div className="grid grid-cols-12 border-t-2 border-border-primary dark:border-rb-dark-mode-lighter">
      <div className="flex items-center col-span-2 border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
        <Reception4 className="text-white bg-gray-950 dark:bg-rb-dark-mode-lighter" style={{ padding: 2 }} />
        <p className="ml-2 font-bold dark:text-white">Total Social</p>
      </div>
      <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
        <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Total Impr.</p>
        <p className="font-bold text-sm dark:text-white">{separateThousands(totalImpression)}</p>
      </div>
      <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
        <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Inf. Price</p>
        <p className="font-bold text-sm dark:text-white">{currencyFormat(influencerPrice.toFixed(2), campaign.currency_symbol)}</p>
      </div>
      <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
        <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Gross Reach</p>
        <p className="font-bold text-sm dark:text-white">{separateThousands(grossReach)}</p>
      </div>
      <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
        <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Adv. Price</p>
        <p className="font-bold text-sm dark:text-white">{currencyFormat(advertiserPrice.toFixed(2), campaign.currency_symbol)}</p>
      </div>
      <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
        <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Buyouts</p>
        <p className="font-bold text-sm dark:text-white">{currencyFormat(buyoutPrice.toFixed(2), campaign.currency_symbol)}</p>
      </div>
      <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
        <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">KSA Tax</p>
        <p className="font-bold text-sm dark:text-white">{currencyFormat(ksaPrice.toFixed(2), campaign.currency_symbol)}</p>
      </div>
      <InfluencerPayoutMarginColumn
        influencer={influencer}
        campaignScenario={campaignScenario}
        totalSocialGroup={totalSocialGroup}
        actions={actions}
      />
      <AdvertiserMarginColumn
        influencer={influencer}
        campaignScenario={campaignScenario}
        totalSocialGroup={totalSocialGroup}
        actions={actions}
      />
    </div>
  )
})